import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.array.sort.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { fuzzyScore, createMatches as createFuzzyMatches } from './filters.js';
import { sep } from './path.js';
import { isWindows } from './platform.js';
import { stripWildcards } from './strings.js';
var NO_SCORE2 = [undefined, []];
export function scoreFuzzy2(target, query) {
  var patternStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var wordStart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  // Score: multiple inputs
  var preparedQuery = query;

  if (preparedQuery.values && preparedQuery.values.length > 1) {
    return doScoreFuzzy2Multiple(target, preparedQuery.values, patternStart, wordStart);
  } // Score: single input


  return doScoreFuzzy2Single(target, query, patternStart, wordStart);
}

function doScoreFuzzy2Multiple(target, query, patternStart, wordStart) {
  var totalScore = 0;
  var totalMatches = [];

  var _iterator = _createForOfIteratorHelper(query),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var queryPiece = _step.value;

      var _doScoreFuzzy2Single = doScoreFuzzy2Single(target, queryPiece, patternStart, wordStart),
          _doScoreFuzzy2Single2 = _slicedToArray(_doScoreFuzzy2Single, 2),
          score = _doScoreFuzzy2Single2[0],
          matches = _doScoreFuzzy2Single2[1];

      if (typeof score !== 'number') {
        // if a single query value does not match, return with
        // no score entirely, we require all queries to match
        return NO_SCORE2;
      }

      totalScore += score;
      totalMatches.push.apply(totalMatches, _toConsumableArray(matches));
    } // if we have a score, ensure that the positions are
    // sorted in ascending order and distinct

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return [totalScore, normalizeMatches(totalMatches)];
}

function doScoreFuzzy2Single(target, query, patternStart, wordStart) {
  var score = fuzzyScore(query.original, query.originalLowercase, patternStart, target, target.toLowerCase(), wordStart, true);

  if (!score) {
    return NO_SCORE2;
  }

  return [score[0], createFuzzyMatches(score)];
}

function normalizeMatches(matches) {
  // sort matches by start to be able to normalize
  var sortedMatches = matches.sort(function (matchA, matchB) {
    return matchA.start - matchB.start;
  }); // merge matches that overlap

  var normalizedMatches = [];
  var currentMatch = undefined;

  var _iterator2 = _createForOfIteratorHelper(sortedMatches),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var match = _step2.value;

      // if we have no current match or the matches
      // do not overlap, we take it as is and remember
      // it for future merging
      if (!currentMatch || !matchOverlaps(currentMatch, match)) {
        currentMatch = match;
        normalizedMatches.push(match);
      } // otherwise we merge the matches
      else {
        currentMatch.start = Math.min(currentMatch.start, match.start);
        currentMatch.end = Math.max(currentMatch.end, match.end);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return normalizedMatches;
}

function matchOverlaps(matchA, matchB) {
  if (matchA.end < matchB.start) {
    return false; // A ends before B starts
  }

  if (matchB.end < matchA.start) {
    return false; // B ends before A starts
  }

  return true;
}
/**
 * Helper function to prepare a search value for scoring by removing unwanted characters
 * and allowing to score on multiple pieces separated by whitespace character.
 */


var MULTIPLE_QUERY_VALUES_SEPARATOR = ' ';
export function prepareQuery(original) {
  if (typeof original !== 'string') {
    original = '';
  }

  var originalLowercase = original.toLowerCase();

  var _normalizeQuery = normalizeQuery(original),
      pathNormalized = _normalizeQuery.pathNormalized,
      normalized = _normalizeQuery.normalized,
      normalizedLowercase = _normalizeQuery.normalizedLowercase;

  var containsPathSeparator = pathNormalized.indexOf(sep) >= 0;
  var values = undefined;
  var originalSplit = original.split(MULTIPLE_QUERY_VALUES_SEPARATOR);

  if (originalSplit.length > 1) {
    var _iterator3 = _createForOfIteratorHelper(originalSplit),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var originalPiece = _step3.value;

        var _normalizeQuery2 = normalizeQuery(originalPiece),
            pathNormalizedPiece = _normalizeQuery2.pathNormalized,
            normalizedPiece = _normalizeQuery2.normalized,
            normalizedLowercasePiece = _normalizeQuery2.normalizedLowercase;

        if (normalizedPiece) {
          if (!values) {
            values = [];
          }

          values.push({
            original: originalPiece,
            originalLowercase: originalPiece.toLowerCase(),
            pathNormalized: pathNormalizedPiece,
            normalized: normalizedPiece,
            normalizedLowercase: normalizedLowercasePiece
          });
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return {
    original: original,
    originalLowercase: originalLowercase,
    pathNormalized: pathNormalized,
    normalized: normalized,
    normalizedLowercase: normalizedLowercase,
    values: values,
    containsPathSeparator: containsPathSeparator
  };
}

function normalizeQuery(original) {
  var pathNormalized;

  if (isWindows) {
    pathNormalized = original.replace(/\//g, sep); // Help Windows users to search for paths when using slash
  } else {
    pathNormalized = original.replace(/\\/g, sep); // Help macOS/Linux users to search for paths when using backslash
  }

  var normalized = stripWildcards(pathNormalized).replace(/\s/g, '');
  return {
    pathNormalized: pathNormalized,
    normalized: normalized,
    normalizedLowercase: normalized.toLowerCase()
  };
}

export function pieceToQuery(arg1) {
  if (Array.isArray(arg1)) {
    return prepareQuery(arg1.map(function (piece) {
      return piece.original;
    }).join(MULTIPLE_QUERY_VALUES_SEPARATOR));
  }

  return prepareQuery(arg1.original);
} //#endregion